import { render } from "./PageNotFound.vue?vue&type=template&id=6d4ac3b0&bindings={}"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script